(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[991],{

/***/ 19455:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/photo",
      function () {
        return __webpack_require__(73560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90978);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82283);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_wrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65409);
/* harmony import */ var _components_seo_pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90423);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);













var Photo = function(param) {
    var menuDetail = param.menuDetail, cate = param.cate, data = param.data;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_10__/* .useTranslations */ .T_)("media.photo");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), previewSrc = ref1[0], setPreviewSrc = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), previewVisible = ref2[0], setPreviewVisible = ref2[1];
    var previewVisibleChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(visible) {
        setPreviewVisible(visible);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-7f808e64f631a62",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-7f808e64f631a62" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container), "m-1600") || ""),
                    children: [
                        (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_8__/* .getHead */ .c)(menuDetail),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "jsx-7f808e64f631a62",
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-7f808e64f631a62" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().head) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "jsx-7f808e64f631a62" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().category) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-7f808e64f631a62" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active), Number(router.query.category_id) == 0 || !router.query.category_id)) || ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "".concat(router.pathname, "?category_id=0&order=").concat(router.query.order || 1, "&page=").concat(router.query.page || 1),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "jsx-7f808e64f631a62",
                                                    children: t("all")
                                                })
                                            })
                                        }),
                                        cate.map(function(item) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "jsx-7f808e64f631a62" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active), router.query.category_id == item.id)) || ""),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "".concat(router.pathname, "?category_id=").concat(item.id, "&order=").concat(router.query.order || 1, "&page=").concat(router.query.page || 1),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "jsx-7f808e64f631a62",
                                                        children: item["title_".concat(router.locale)]
                                                    })
                                                })
                                            }, item.id);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "jsx-7f808e64f631a62" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().sort) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-7f808e64f631a62",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "".concat(router.pathname, "?category_id=").concat(router.query.category_id || 0, "&order=1&page=").concat(router.query.page || 1),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "jsx-7f808e64f631a62" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active), Number(router.query.order) == 1 || !router.query.order)) || ""),
                                                    children: t("sort1")
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-7f808e64f631a62",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "".concat(router.pathname, "?category_id=").concat(router.query.category_id || 0, "&order=2&page=").concat(router.query.page || 1),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "jsx-7f808e64f631a62" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active), Number(router.query.order) == 2)) || ""),
                                                    children: t("sort2")
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "jsx-7f808e64f631a62" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().list) || ""),
                            children: !!(data === null || data === void 0 ? void 0 : data.list) && (data === null || data === void 0 ? void 0 : (ref = data.list) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-7f808e64f631a62" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item) || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: item.photo,
                                        alt: item["brief_".concat(router.locale)],
                                        loading: "lazy",
                                        onClick: function() {
                                            setPreviewSrc(item.photo);
                                            previewVisibleChange(true);
                                        },
                                        className: "jsx-7f808e64f631a62"
                                    })
                                }, item.id);
                            }))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_4__/* .ImagePreview */ .eT, {
                            src: previewSrc,
                            visible: previewVisible,
                            onVisibleChange: previewVisibleChange
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_pagination__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            page: Number(router.query.page || 1),
                            total: data === null || data === void 0 ? void 0 : data.total,
                            size: data === null || data === void 0 ? void 0 : data.list_rows
                        })
                    ]
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "7f808e64f631a62",
                children: ".semi-portal{z-index:99999!important}.semi-image-preview-image-img{max-width:none!important}"
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Photo);


/***/ }),

/***/ 82283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"photo_m-1600__LOMBh","container":"photo_container__uKIcH","head":"photo_head__FgQok","category":"photo_category__ZSZTQ","item":"photo_item__fncu0","active":"photo_active__ymurn","sort":"photo_sort__b0EqV","list":"photo_list__l9J6Z"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [330,774,888,179], function() { return __webpack_exec__(19455); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);